import React from 'react'
import moment from 'moment'
import { MdOutlineClose } from "react-icons/md";

const View = ({ data, onClose }) => {
  return (

    <div>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-md w-[90%] md:w-2/3 lg:w-2/3">
          <div className="flex justify-between items-center mb-4 border-b pb-3">
            <h2 className="text-xl font-semibold text-gray-800">Details</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-red-500">
              <MdOutlineClose className='w-9 h-9 bg-gray-100 rounded-full p-1' />
            </button>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
            <div>
              <label className='block text-sm font-medium text-black'>Title:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.title || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Description:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.desc || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Send at:</label>
              <input disabled type="text" id="l_name" name='l_name' value={moment(data.created_at).format('YYYY-MM-DD / hh:mm A')} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
          </div>
          {/* <div className="flex justify-end mt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default View